<template>
  <div class="app-layout">
    <div class="header">
      <Strong>LTL</strong>Kassa

      <div v-if="loggedIn" class="loggedin-info">
        {{ loginName }}
        <button @click.stop="logout()">Abmelden</button>
      </div>
    </div>
    <div class="content" v-if="loggedIn && loaded">
      <div class="sidebar">
        <div class="row" v-if="!selectedEventSet">
          <form-input label="Vorstellung suchen" v-model="query" search-field></form-input>
        </div>

        <div class="row" v-else>
          <button @click.stop="startNewSearch()">neue Suche</button>
        </div>

        <div class="search-results" v-if="!selectedEventSet">
          <div class="search-result" v-for="item in eventsets" :key="item.id.ref" @click.stop="selectedEventSet=item.id.EventSetID">
            <label>{{ item.text }}</label>
            <div class="data-time">VeranstaltungsNr: {{ item.id.EventSetID }}</div>
          </div>
        </div>

        <div class="search-results" v-if="events.length > 0">
          <div class="search-result" v-for="e of events" :key="e.ID" :class="{
            selected: event == e.ID
          }" @click.stop="onEventSelect(e)">
            <label>{{ e.Name }}</label>
            <div class="data-time">{{ e.DateTime }} </div>
            <div class="prices">{{ getFromToPrices(e) }}</div>
          </div>
        </div>
      </div>
      <div class="main">
        <seatplan-view v-if="event !== null" ref="seatplanview" :seats-in-cart="seatsInCart" :event="event" 
          @submit="submitToCart($event)" 
          :categoryList="categoryList" 
          @cancel="cancelProcess()"
          @createreservation="createReservation()" @clear="cancelOrder()">
          
        </seatplan-view>
        <my-cart v-if="event === null && seatsInCart.length > 0" @cancel="cancelOrder()" :orderinfo="orderInfo" :seatsInCart="seatsInCart" @neworder="initNewOrder()"></my-cart>
      </div>
    </div>
    <div v-if="!loggedIn && loaded" class="kassa-loginform-wrapper">
      <div  class="kassa-loginform">
        <h3>Login</h3>
        <p>
          <form-input label="EMail Webshop*" v-model="username"></form-input>
        </p>
        <p>
          <form-input label="Passwort Webshop*" type="password" v-model="password"></form-input>
        </p>
        <button class="btn btn-black" @click.once.stop="login()">Anmelden</button>
      </div>
    </div>

    <div v-if="!loaded">
      <spinner></spinner>
    </div>
    
    <div class="footer">
      &copy; Lemon42
      <div class="hidden">
      <form ref="cartdataForm" v-show="false" :action="API" target="cart_target" method="POST">
        <textarea name="extracartdata" ref="cartData"></textarea>
      </form>
      <iframe id="cart_target" name="cart_target" :src="IFRAME_CART"></iframe>
      </div>
    </div>
  </div>
</template>


<script>
import FormInput from '@/components/forms/Input.vue'
import SeatplanView from '@/components/SeatplanView.vue'
import MyCart from '@/components/MyCart.vue'
import Spinner from '@/components/Spinner.vue'
import axios from 'axios'
import debounce from 'lodash/debounce'
import { mapState } from 'vuex'

export default {
  components: { FormInput, SeatplanView, Spinner, MyCart },
  data() {
    return {
      event: null,
      categoryList: [],
      seatsInCart: [],
      query: '',
      eventsets: [],
      events: [],
      selectedEventSet: null,
      username: '',
      password: '',
      loaded: false,
      orderInfo : {}
    }
  },
  computed: {
    ...mapState(['API', 'CHECKOUT_PAGE', 'IFRAME_CART', 'loggedIn', 'loginName'])
  },
  watch: {
    query(q = '') {
      this.searchEventSets(q)
    },
    selectedEventSet(eventset) {
      if (eventset) {
        this.getEvents(eventset)
      }
    }
  },
  methods: {
    async relaodCategories(){
      const categories = {};

      const {data: categoryList } = await axios.get(this.API, {
        params: {
          action: 'getEventCategoryList',
          eventId: this.event
        }
      })

      categoryList.filter(c => c.Count > 0).forEach(c => {
        if (!categories[c.ID]) {
          categories[c.ID] = {
            ...c
          }
        } else {
          categories[c.ID].Count += c.Count;
        }
      })

      this.categoryList = Object.values(categories);
    },
    async _searchEventSets(q) {
      console.log(q)
      const {data: resp} = await axios.get(this.API, {
        params: {
          action: 'findEventSetsByName',
          q
        }
      })

      this.eventsets = resp.results
    },
    async getEvents(eventset) {
      
      const {data: resp} = await axios.get(this.API, {
        params: {
          action: 'getEvents',
          eventset,
        }
      })

      this.events = resp
    },

    getFromToPrices(e) {
      if (Array.isArray(e.CategoryList)) {
        if (e.CategoryList.length === 2) {
          const [from, to] = e.CategoryList
          return `Karten von-bis: ${from.Price} € - ${to.Price}€`
        }
        if (e.CategoryList.length === 1) {
          const [from] = e.CategoryList
          return `${from.Price} €`
        }
      }

      return 'ausverkauft'
    },
    async onEventSelect(e) {
      this.event = e.ID
      this.relaodCategories()
    },
    cancelProcess() {
      this.event = null;
      this.selectedEventSet = null;
      this.events = []
      this.categoryList = []
    },
    login() {
      this.loaded = false
      this.$refs.cartData.value = JSON.stringify({
        type:"login",
        username: this.username,
        password: this.password
      });
      this.$refs.cartdataForm.submit()
    },
    logout() {
      this.loaded = false
      this.$refs.cartData.value = JSON.stringify({
        type:"logout"
      });
      this.$refs.cartdataForm.submit()
    },
    submitToCart(data={}) {
      data.event = this.event
      this.$refs.cartData.value = JSON.stringify(data);
      this.$refs.cartdataForm.submit()
    },

    createReservation() {
      this.loaded = false
      this.event = null;
      this.loaded = false;
      this.$refs.cartData.value = JSON.stringify({
        type: 'createReservation'
      })
      this.$refs.cartdataForm.submit()
    },
    removeSeats() {
      this.$refs.cartData.value = JSON.stringify({
        event: this.event,
        type: 'removeSeats',
      });
      this.$refs.cartdataForm.submit()
    },
    initNewOrder() {
      this.$refs.cartData.value = JSON.stringify({
        type: 'newCart',
      });
      this.$refs.cartdataForm.submit()
    },
    async onOrderInfoSeats({ data } = {}) {
      try {
        if (Array.isArray(data.seats)) {
          this.seatsInCart = data.seats
        }

        this.$store.commit('SET_LOGGEDIN', data.loggedIn)
        this.$store.commit('SET_LOGINNAME', data.loginName)

        this.orderInfo = data.orderInfo
      } catch (e) {
        console.error(e)
      }
      
      this.loaded = true;

    },
    startNewSearch() {
      this.event = null
      this.selectedEventSet = null
      this.events = []
    },
    cancelOrder() {
      this.$refs.cartData.value = JSON.stringify({
        event: this.event,
        type: 'removeSeats',
      });

      this.$refs.cartdataForm.submit()
    },
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onOrderInfoSeats, false);
  },
  async created() {
    this.loaded = false
    window.addEventListener("message", this.onOrderInfoSeats, false);
    await this.relaodCategories()
    this.searchEventSets = debounce(this._searchEventSets.bind(this), 500);
    
  }
}
</script>


<style lang="scss" scoped>
.app-layout {
  height: 100vh;
  display: grid;
  grid-template-rows: 48px 1fr 32px;

  * {
    box-sizing: border-box;
  }
  .content {
    display: grid;
    grid-template-columns: 350px 1fr;
    grid-template-rows: auto 1fr;
    height: calc(100vh - 48px - 32px);
    .sidebar {
      background-color: #fafafa;
      border-right: 1px solid #333;
      height: calc(100vh - 48px - 32px);
      display: grid;
      grid-template-rows: 86px 1fr;
      padding: 0;
      .row {
        padding: 16px 8px;
        border-bottom: 2px solid goldenrod;
      }
    }
  }

}

.header, .footer {
  background: black;
  color: white;
  padding: 8px;
  display: flex;
  align-items: center;
}

.header {
  font-size: 32px;
  font-weight: 100;
  border-bottom: 2px solid goldenrod;
}

.loggedin-info {
  margin: auto 0;
  font-size: 18px;
  font-weight: 300;
  margin-left: auto;
  button {
    padding: 4px 8px;
  }
}

.footer {
  height: 32px;
  font-size: 12px;
}

.search-results {
  overflow-y: auto;
}

.search-result {
  font-size: 18px;
  line-height: 24px;
  font-weight: 400;
  padding: 8px;
  position: relative;
  overflow: hidden;

  cursor: pointer;

  label {
    font-weight: 300;
  }
  border-bottom: 1px solid goldenrod;

  &:nth-child(odd) {
    background-color: #fdfbecfa;
  }

  &:hover {
    background-color: #ccc;
  }

  &.selected {
    background-color: black;
    color: white;
    &:before {
      position: absolute;
      content: 'keyboard_arrow_right';
      top: 50%;
      right: 0;
      transform: translateY(-50%);
      font-size: 34px;
    }
  }
  
}

.prices {
  font-size: 14px;
}


.kassa-loginform-wrapper {
  position: relative;
}

.kassa-loginform {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  height: auto;
  padding: 8px;
  border: 4px solid black;
  box-shadow: 1px 1px 8px 0px #333;
  border-radius: 4px;
}

h3 {
  margin: 8px 0 8px 0;
  border-bottom: 1px solid black;
}
</style>


<style lang="scss">
i.icon,
.search-result.selected::before {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

iframe {
  width: 0; height: 0; border: none;
}


button {
  background-color: goldenrod;
  border: 1px solid goldenrod;
  border-radius: 0;
  outline: none;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 400;
  text-transform: uppercase;
  transition: all 0.35s ease-in-out;
  padding: 8px 16px;
  
  &.btn-black {
    background-color: black;
    color: white;
    width: 100%;
    margin: 16px 0;
  }
}
</style>